export type ProposalPriceCatalog = {
  offers?: Array<{ id: string; title: string }>;
  variants?: Array<{
    offerId: string;
    label?: string | null;
    durationMinutes?: number;
    priceCents?: number | null;
  }>;
};

export type ProposalPriceIdentity = {
  offerTitle: string;
  variantLabel?: string;
  durationMinutes?: number;
  priceCents?: number | null;
};

export type ProposalPriceDisplay = {
  standardPriceCents: number | null;
  personalPriceCents: number | null;
};

export function resolveProposalPrices(
  proposal: ProposalPriceIdentity,
  catalog: ProposalPriceCatalog,
): ProposalPriceDisplay {
  const offer = catalog.offers?.find(
    (candidate) => normalize(candidate.title) === normalize(proposal.offerTitle),
  );
  const variants = offer
    ? (catalog.variants ?? []).filter((candidate) => candidate.offerId === offer.id)
    : [];

  const variant =
    variants.find(
      (candidate) =>
        normalize(candidate.label) === normalize(proposal.variantLabel) &&
        candidate.durationMinutes === proposal.durationMinutes,
    ) ??
    variants.find((candidate) => candidate.durationMinutes === proposal.durationMinutes) ??
    variants.find((candidate) => normalize(candidate.label) === normalize(proposal.variantLabel));

  const standardPriceCents = normalizePrice(variant?.priceCents);
  const effectivePriceCents = normalizePrice(proposal.priceCents);

  if (standardPriceCents === null) {
    return {
      standardPriceCents: effectivePriceCents,
      personalPriceCents: null,
    };
  }

  return {
    standardPriceCents,
    personalPriceCents:
      effectivePriceCents !== null && effectivePriceCents !== standardPriceCents
        ? effectivePriceCents
        : null,
  };
}

function normalize(value: string | null | undefined): string {
  return value?.trim().toLocaleLowerCase("de-DE") ?? "";
}

function normalizePrice(value: number | null | undefined): number | null {
  return Number.isFinite(value) && value !== null && value !== undefined
    ? Math.round(value)
    : null;
}
